export default __webpack_public_path__ + "static/media/icon-visitforms.15464854.svg";